export default __webpack_public_path__ + "static/media/gilboa2.7e28fddf.jpg";